(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koto-collection-icons"] && !Shopify.designMode) return;
  try {
    
  function placeHeaderNav() {
    const source = document.querySelector('.koto-header-nav');
    const dest = document.querySelector('[data-header-sticky-collections]');
    if (!source || !dest || dest.contains(source)) return;
    dest.appendChild(source);
    dest.removeAttribute('hidden');
  }

  function initKotoNav(root) {
    if (!root || root.dataset.kotoBrandsReady === 'true') return;
    root.dataset.kotoBrandsReady = 'true';

    const host =
      document.querySelector('#header-group .header-section') || document.querySelector('#header-component');
    const items = [...root.querySelectorAll('[data-koto-item]')];
    let closeTimer;
    let openItem = null;

    items.forEach((item) => {
      item.mega = item.querySelector('[data-koto-shop-mega]');
      item.trigger = item.querySelector('[data-koto-shop-trigger]');
    });

    function park(item) {
      if (!item || !item.mega) return;
      item.classList.remove('is-open');
      if (item.trigger) item.trigger.setAttribute('aria-expanded', 'false');
      item.mega.hidden = true;
      item.appendChild(item.mega);
    }

    function closeAll() {
      clearTimeout(closeTimer);
      items.forEach(park);
      openItem = null;
    }

    function openItemMenu(item) {
      if (!item || !item.mega) return;
      if (openItem && openItem !== item) park(openItem);
      item.classList.add('is-open');
      item.trigger.setAttribute('aria-expanded', 'true');
      if (host) host.appendChild(item.mega);
      item.mega.hidden = false;
      item.mega.querySelector('.koto-shop__layout')?.scrollTo(0, 0);
      openItem = item;
    }

    function hovered() {
      return items.some((item) => item.matches(':hover')) || Boolean(openItem?.mega?.matches(':hover'));
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        if (!hovered()) closeAll();
      }, 180);
    }

    items.forEach((item) => {
      item.addEventListener('pointerenter', () => {
        clearTimeout(closeTimer);
        openItemMenu(item);
      });
      item.addEventListener('pointerleave', scheduleClose);
      item.trigger?.addEventListener('click', (event) => {
        event.preventDefault();
        if (openItem === item) closeAll();
        else openItemMenu(item);
      });
      item.mega?.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      item.mega?.addEventListener('pointerleave', scheduleClose);
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Node)) return;
      if (root.contains(target)) return;
      if (openItem?.mega?.contains(target)) return;
      closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  }

  if (document.querySelector('[data-header-sticky-collections]')) {
    placeHeaderNav();
    document.querySelectorAll('[data-koto-brands]').forEach(initKotoNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koto-hero"] && !Shopify.designMode) return;
  try {
    
  function initKotoHero(root) {
    const track = root.querySelector('[data-koto-track]');
    const originals = [...root.querySelectorAll('[data-koto-slide]')];
    if (!track || originals.length < 2) return;

    function cloneSlide(slide) {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('data-koto-slide');
      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
      return clone;
    }

    originals.slice().reverse().forEach((slide) => track.prepend(cloneSlide(slide)));
    originals.forEach((slide) => track.append(cloneSlide(slide)));

    const slides = [...track.children];
    const count = originals.length;
    let index = count;
    let animating = false;
    let timer = null;
    const autoplay = root.dataset.autoplay !== 'false' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const speed = Number(root.dataset.speed || 5) * 1000;

    function offsetFor(i) {
      const viewport = root.querySelector('.koto-hero__viewport');
      const slide = slides[i];
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const viewportWidth = viewport.clientWidth;
      const slideWidth = slide.getBoundingClientRect().width;
      const left = slides.slice(0, i).reduce((sum, el) => sum + el.getBoundingClientRect().width + gap, 0);
      return left - (viewportWidth - slideWidth) / 2;
    }

    function setActive(i) {
      const real = ((i % count) + count) % count;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex % count === real);
      });
    }

    function jump(i) {
      track.classList.add('is-instant');
      index = i;
      track.style.transform = `translate3d(${-offsetFor(index)}px, 0, 0)`;
      setActive(index);
      track.getBoundingClientRect();
      track.classList.remove('is-instant');
    }

    function go(next) {
      if (animating) return;
      animating = true;
      index = next;
      setActive(index);
      track.style.transform = `translate3d(${-offsetFor(index)}px, 0, 0)`;
    }

    function onEnd(event) {
      if (event.target !== track || event.propertyName !== 'transform') return;
      animating = false;
      if (index >= count * 2) jump(index - count);
      else if (index < count) jump(index + count);
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(() => go(index + 1), speed);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    track.addEventListener('transitionend', onEnd);
    root.querySelector('[data-koto-prev]')?.addEventListener('click', () => {
      go(index - 1);
      start();
    });
    root.querySelector('[data-koto-next]')?.addEventListener('click', () => {
      go(index + 1);
      start();
    });
    window.addEventListener('resize', () => jump(count + (((index % count) + count) % count)));

    root.querySelectorAll('.koto-hero__image').forEach((image) => {
      if (image.complete) return;
      image.addEventListener('load', () => jump(count + (((index % count) + count) % count)), { once: true });
    });

    jump(count);
    start();
  }

  document.querySelectorAll('[data-koto-hero]:not([data-koto-hero-ready])').forEach((root) => {
    root.dataset.kotoHeroReady = 'true';
    initKotoHero(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
